import Vue from 'vue'
import Router from 'vue-router'
import routes from './router'
import auth from '../common/auth'

Vue.use(Router)

const router = new Router({
  base:'/titan-anyida',
  routes: routes
})

router.beforeEach((route,redirect,next)=>{
  if(!auth.loggedIn() && route.path !== '/login' && route.path !== '/passport'){
    next({
      path:'/login'
    })
  } else {
    next();
  }
  // if(!auth.loggedIn() && route.path !== '/login'){
  //   next({
  //     path:'/login',
  //     query:{redirect:route.fullPath}
  //   })
  // }else{    
  //   next();
  // }
})
router.afterEach((to, from) => {
  
})
export default router;




// WEBPACK FOOTER //
// ./src/router/index.js